var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertyOwnership({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_No_properties_-_Flaticon-2",
    "data-name": "Search results for No properties - Flaticon-2",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9882",
    "data-name": "Path 9882",
    d: "M51,1a50,50,0,1,0,50,50A50,50,0,0,0,51,1Zm0,96.774A46.774,46.774,0,1,1,97.774,51,46.774,46.774,0,0,1,51,97.774Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9883",
    "data-name": "Path 9883",
    d: "M18.055,16.619a1.634,1.634,0,0,0-1.235-.469,1.613,1.613,0,0,0-1.171.611A39.9,39.9,0,0,0,7,41.716,40.368,40.368,0,0,0,47.323,82.039,39.911,39.911,0,0,0,72.279,73.39a1.613,1.613,0,0,0,.14-2.406ZM25,39.371l-2.881-3.842,5.645-4.645,3.3,3.3Zm8.344-2.9L40.871,44V59.458H31.194V38.311Zm17.2,22.99H44.1V47.222l6.452,6.452ZM53.774,56.9l2.558,2.558H53.774Zm5.784,5.784,3.226,3.226H27.968V62.684ZM47.323,78.813a37.139,37.139,0,0,1-37.1-37.1,36.679,36.679,0,0,1,6.861-21.5L25.474,28.6l-6.59,5.427a1.613,1.613,0,0,0-.271,2.2l4.839,6.452a1.613,1.613,0,0,0,2.34.256l2.176-1.869V59.458H26.355a1.613,1.613,0,0,0-1.613,1.613v6.452a1.613,1.613,0,0,0,1.613,1.613H66.01l2.816,2.815a36.694,36.694,0,0,1-21.5,6.863Z",
    transform: "translate(3.677 9.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9884",
    "data-name": "Path 9884",
    d: "M41.716,7A39.911,39.911,0,0,0,16.76,15.648a1.613,1.613,0,0,0-.14,2.406L70.984,72.419a1.613,1.613,0,0,0,1.14.473h.1a1.613,1.613,0,0,0,1.171-.611,39.9,39.9,0,0,0,8.648-24.958A40.368,40.368,0,0,0,41.716,7ZM59.458,30.813,53.007,25.5V23.129h6.452ZM66.92,41.136l-2.881,3.842L42.766,26.752a1.613,1.613,0,0,0-2.1,0l-5.806,4.984-3.124-3.124,9.977-8.224Zm-9.074,2.781V54.723l-20.7-20.708,4.576-3.923ZM71.952,68.824,61.071,57.945V46.678l2.176,1.866a1.613,1.613,0,0,0,2.34-.253l4.839-6.452a1.613,1.613,0,0,0-.265-2.211l-7.477-6.158V21.516A1.613,1.613,0,0,0,61.071,19.9H51.394a1.613,1.613,0,0,0-1.613,1.613v1.327l-7.039-5.8a1.613,1.613,0,0,0-2.052,0L29.439,26.313l-9.226-9.224a36.694,36.694,0,0,1,21.5-6.863,37.139,37.139,0,0,1,37.1,37.1A36.679,36.679,0,0,1,71.952,68.824Z",
    transform: "translate(9.284 3.677)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyOwnership);
export default __webpack_public_path__ + "static/media/propertyOwnership.3001386a4dbe4c76a9376bcb7ceed1c5.svg";
export { ForwardRef as ReactComponent };